import React from "react";

function Button(props) {
  const { variant } = props;

  var button;

  if (variant == "text") {
    button = (
      <span {...props}>
        <button className="active:opacity-50 uppercase p-2 text-primary">
          {props.children}
        </button>
      </span>
    );
  } else if (variant == "outlined") {
    button = (
      <span {...props}>
        <button className="bg-primary hover:bg-primaryDark  disabled:hover:bg-primary transition-all p-2 px-4 rounded-md uppercase drop-shadow-lg active:scale-105 flex justify-center items-center text-white  hover:drop-shadow-2xl duration-300 disabled:opacity-50 disabled:active:scale-100">
          {props.children}
        </button>
      </span>
    );
  } else {
    // contained
    button = (
      <span {...props}>
        <button className="bg-primary hover:bg-primaryDark  disabled:hover:bg-primary transition-all p-2 px-4 rounded-md uppercase drop-shadow-lg active:scale-105 flex justify-center items-center text-white  hover:drop-shadow-2xl duration-300 disabled:opacity-50 disabled:active:scale-100">
          {props.children}
        </button>
      </span>
    );
  }

  return button;
}

export default Button;
